import React, { useEffect } from 'react'
import { mappingType, selectedMappingId } from 'Pages/Admin/AdminMapping/@signals'
import { Grid, Skeleton } from '@mui/material'
import { AppFormSection } from '@components'
import {
	AcrissSelector,
	AirConditionSelector,
	CarModelSelector,
	CategorySelector,
	DoorsSelector,
	OfficeCountrySelector,
	ProvidersSelector,
	SeatsSelector,
	SitesSelector,
	TransmissionSelector,
	UserSelector,
	NewCategorySelector,
	OfficeSelector,
	CountrySelector,
	NewAcrissSelector,
	CompanySelector,
	IsCompanySelector,
} from 'Pages/Admin/AdminMapping/EditDrawer/Content/@selectors'
import { MAPPING_TYPE } from 'Pages/Admin/AdminMapping/@constants'
import useAdminMappingForm from 'Pages/Admin/AdminMapping/EditDrawer/@hooks/useForm'

const SelectorWithSkeleton = ({ isLoading, SelectorComponent, condition = true, xs = 6 }) => (
	condition && (
		<Grid item xs={xs} container alignItems="flex-start">
			{isLoading ? <Skeleton variant="rounded" width="100%" height={40} sx={{ borderRadius: '8px' }}/> : <SelectorComponent/>}
		</Grid>
	)
)

export default function AdminMappingDrawerContent() {
	const { getMapping, isLoadingForm } = useAdminMappingForm('edit')

	useEffect(() => {
		getMapping()
	}, [selectedMappingId.value])

	return (
		<>
		<AppFormSection icon="location-dot" title="Where it applies">
		<Grid container spacing={2}>
			<SelectorWithSkeleton isLoading={isLoadingForm} SelectorComponent={OfficeCountrySelector} xs={6}/>
			<SelectorWithSkeleton isLoading={isLoadingForm} SelectorComponent={IsCompanySelector} xs={6}/>
			<Grid item xs={6} container alignItems="flex-start">
				{isLoadingForm ? <Skeleton variant="rounded" width="100%" height={40} sx={{ borderRadius: '8px' }}/> : <>
					<OfficeSelector/>
					<CountrySelector/>
				</>}
			</Grid>
			<Grid item xs={6} container alignItems="flex-start">
				{isLoadingForm ? <Skeleton variant="rounded" width="100%" height={40} sx={{ borderRadius: '8px' }}/> : <>
					<UserSelector/>
					<CompanySelector/>
				</>}
			</Grid>
			<SelectorWithSkeleton isLoading={isLoadingForm} SelectorComponent={SitesSelector}/>
			<SelectorWithSkeleton isLoading={isLoadingForm} SelectorComponent={ProvidersSelector}/>
		</Grid>
		</AppFormSection>
		<AppFormSection icon="car" title="Vehicle">
		<Grid container spacing={2}>
			<SelectorWithSkeleton isLoading={isLoadingForm} SelectorComponent={AcrissSelector} condition={mappingType.value === MAPPING_TYPE.ACRISS}/>
			<SelectorWithSkeleton isLoading={isLoadingForm} SelectorComponent={NewAcrissSelector} condition={mappingType.value === MAPPING_TYPE.ACRISS}/>
			<SelectorWithSkeleton isLoading={isLoadingForm} SelectorComponent={CarModelSelector}/>
			<SelectorWithSkeleton isLoading={isLoadingForm} SelectorComponent={CategorySelector} condition={mappingType.value === MAPPING_TYPE.CATEGORY}/>
			<SelectorWithSkeleton isLoading={isLoadingForm} SelectorComponent={NewCategorySelector} condition={mappingType.value === MAPPING_TYPE.CATEGORY}/>
			<SelectorWithSkeleton isLoading={isLoadingForm} SelectorComponent={TransmissionSelector}/>
			<SelectorWithSkeleton isLoading={isLoadingForm} SelectorComponent={DoorsSelector} xs={3}/>
			<SelectorWithSkeleton isLoading={isLoadingForm} SelectorComponent={SeatsSelector} xs={3}/>
			<SelectorWithSkeleton isLoading={isLoadingForm} SelectorComponent={AirConditionSelector} condition={mappingType.value === MAPPING_TYPE.ACRISS}/>
		</Grid>
		</AppFormSection>
		</>
	)
}
